import React from "react";
import { Card, CardContent } from "../../src/components/ui/card.jsx";
import { Label } from "../../src/components/ui/label.jsx";
import { Badge } from "../../src/components/ui/badge.jsx";
import { Building, Check } from "lucide-react";

export default function CouncilSelector({ councils, selectedCouncil, onSelect }) {
  const colorFor = (abbrev) => {
    switch (abbrev) {
      case 'BCC': return 'border-purple-300 bg-purple-50 dark:border-purple-700 dark:bg-purple-950/20';
      case 'CCC': return 'border-orange-300 bg-orange-50 dark:border-orange-700 dark:bg-orange-950/20';
      case 'WSC': return 'border-green-300 bg-green-50 dark:border-green-700 dark:bg-green-950/20';
      default: return 'border-slate-200 bg-slate-50 dark:border-slate-700 dark:bg-slate-900/50';
    }
  };

  return (
    <div className="space-y-4">
      <Label className="text-slate-700 dark:text-slate-200 font-medium">Select Council</Label>
      <div className="grid md:grid-cols-3 gap-4">
        {councils.map((council) => (
          <Card 
            key={council.abbrev}
            className={`cursor-pointer transition-all duration-200 hover:shadow-md ${colorFor(council.abbrev)} ${
              selectedCouncil === council.name 
                ? 'ring-2 ring-emerald-400 dark:ring-emerald-500' 
                : 'hover:border-slate-300 dark:hover:border-slate-600'
            }`}
            onClick={() => onSelect(council)}
          >
            <CardContent className="p-4">
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-center gap-2">
                  <Building className="w-4 h-4 text-slate-600 dark:text-slate-300" />
                  <Badge variant="outline" className="text-xs">
                    {council.abbrev}
                  </Badge>
                </div>
                {selectedCouncil === council.name && (
                  <Check className="w-4 h-4 text-emerald-600 dark:text-emerald-400" />
                )}
              </div>
              <h4 className="font-semibold text-slate-800 dark:text-slate-100 text-sm mb-1">
                {council.name}
              </h4>
              <p className="text-xs text-slate-500 dark:text-slate-400 truncate">
                ID: {council.entra_id.substring(0, 8)}...
              </p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}